<template>
    <div v-if="!player.is_authorized" class="login-form">
        <div class="login-form__fields">
            <div class="login-form__tabs">
                <div class="login-form__tab" :class="{ 'login-form__tab_active': activeTabIndex === 0 }" @click.prevent="onTabClick(0)">
                    Sign up
                </div>
                <div class="login-form__tab" :class="{ 'login-form__tab_active': activeTabIndex === 1 }" @click.prevent="onTabClick(1)">
                    Sign in
                </div>
            </div>

            <template v-if="activeTabIndex === 0">
                <div class="login-form__field" :class="{ 'login-form__field_error': errors.name }">
                    <span v-if="errors.name" class="login-form__field-error">{{ errors.name }}</span>
                    <input type="text" placeholder="Username" v-model="name" />
                </div>
                <div class="login-form__field" :class="{ 'login-form__field_error': errors.email }">
                    <span v-if="errors.email" class="login-form__field-error">{{ errors.email }}</span>
                    <input type="text" placeholder="Email" v-model="email">
                </div>
                <div class="login-form__field" :class="{ 'login-form__field_error': errors.company }">
                    <span v-if="errors.company" class="login-form__field-error">{{ errors.company }}</span>
                    <input type="text" placeholder="Company" v-model="company">
                </div>

                <div class="login-form__submit">
                    <button class="login-form__submit-label" @click.prevent="onSignUpButtonClick()">Sign up</button>
                    <button class="login-form__submit-arrow" aria-label="Sign up" @click.prevent="onSignUpButtonClick()">
                        <img src="@/assets/img/tournaments/demo-stand/button-arrow-icon.svg" alt="" />
                    </button>
                </div>

                <div v-if="errorsCommon" class="login-form__error-common">{{ errorsCommon }}</div>
            </template>

            <template v-if="activeTabIndex === 1">
                <div class="login-form__field" :class="{ 'login-form__field_error': errors.name }">
                    <span v-if="errors.name" class="login-form__field-error">{{ errors.name }}</span>
                    <input type="text" placeholder="Username" v-model="name" />
                </div>
                <div class="login-form__field" :class="{ 'login-form__field_error': errors.email }">
                    <span v-if="errors.email" class="login-form__field-error">{{ errors.email }}</span>
                    <input type="text" placeholder="Email" v-model="email">
                </div>

                <div class="login-form__submit">
                    <button class="login-form__submit-label" @click.prevent="onLoginButtonClick()">Sign in</button>
                    <button class="login-form__submit-arrow" aria-label="Sign in" @click.prevent="onLoginButtonClick()">
                        <img src="@/assets/img/tournaments/demo-stand/button-arrow-icon.svg" alt="" />
                    </button>
                </div>

                <div v-if="errorsCommon" class="login-form__error-common">{{ errorsCommon }}</div>
            </template>
        </div>
    </div>

    <div class="user-profile-plate" v-if="player.is_authorized">
        <span class="user-profile-plate__name">{{ player.name }}</span>
        <a href="#" class="user-profile-plate__signout" aria-label="Sign out" title="Sign out" @click.prevent="onLogoutClick">
            <span class="user-profile-plate__signout-label">Sign out</span>
            <!-- phones: the label gives way to this exit glyph (see .user-profile-plate__signout-icon) -->
            <svg class="user-profile-plate__signout-icon" viewBox="0 0 16 16" width="16" height="16"
                 fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                 aria-hidden="true" focusable="false">
                <path d="M6 2.5H3.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1H6"/>
                <path d="M10.5 11l3-3-3-3"/>
                <path d="M13.5 8H6.5"/>
            </svg>
        </a>
    </div>
</template>

<script>

import { appFetchJSON, processFetchError } from "@/lib/request_utils";

export default {
    name: "TournamentLoginFormComponent",

    props: {
        player: Object,
        tournament: Object,
    },

    mounted() {

    },

    data() {
        return {
            activeTabIndex: 0,
            name: '',
            email: '',
            company: '',
            errors: {
                name: '',
                email: '',
                company: ''
            },
            errorsCommon: '',
        }
    },

    methods: {
        onTabClick(tabIndex) {
            this.activeTabIndex = tabIndex;
            this.resetErrors();
        },

        onLoginButtonClick() {
            const url = `/tournaments/login`;
            const options = {
                params: {
                    tournament_uid: this.tournament?.uid,
                    email: this.email,
                    name: this.name,
                }
            }
            appFetchJSON(url, options)
                .then(res => {
                    this.$router.go();
                })
                .catch(this.processErrors);
        },

        onSignUpButtonClick() {
            const url = `/tournaments/signup`;
            const options = {
                params: {
                    tournament_uid: this.tournament?.uid,
                    email: this.email,
                    name: this.name,
                    company: this.company,
                }
            }
            appFetchJSON(url, options)
                .then(res => {
                    this.$router.go();
                })
                .catch(this.processErrors);
        },

        onLogoutClick() {
            const url = `/tournaments/logout`;
            appFetchJSON(url)
                .then(res => {
                    this.$router.go();
                })
                .catch(this.processErrors);
        },

        processErrors(err) {
            console.log(err);
            this.resetErrors();
            const res = err.response;
            if (res) {
                res.json().then((data) => {
                    const errors = (data || {}).errors;
                    if (typeof errors === 'string' || errors instanceof String) {
                        this.errorsCommon = errors;
                        return;
                    }

                    if (Array.isArray(errors)) {
                        this.errorsCommon = errors[0];
                        return;
                    }

                    if (errors) {
                        try {
                            for (let [key, val] of Object.entries(errors)) {
                                if (Array.isArray(val)) {
                                    val = val[0];
                                }
                                this.errors[key] = val;
                            }
                        } catch (err) {
                            processFetchError(this.$router, err);
                        }
                        return;
                    } else {
                        processFetchError(this.$router, err);
                    }
                });
            } else {
                processFetchError(this.$router, err);
            }
        },

        resetErrors() {
            this.errors = {};
            this.errorsCommon = '';
        }
    }

}
</script>

<style scoped>
</style>